import { router } from 'expo-router'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import type { TMediumCommunityApi } from '@/src/features/community/api/communityApi.types'
import { useRandomPopularUnprayedIntentionsQuery } from '@/src/features/intention/services/useRandomPopularUnprayedIntentionsQuery'
import { IntentionPrayCard } from '@/src/features/intention/ui/components/IntentionPrayCard'
import { TEST_ID } from '@/src/general/constants/testId'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

type TCommunityRandomIntentionsProps = {
  community: TMediumCommunityApi
  onPray?: VoidFunction
  testID: string
}

export const CommunityRandomIntention = ({
  community,
  onPray: propOnPray,
  testID,
}: TCommunityRandomIntentionsProps): ReactNode => {
  const { routes } = useRoutes()

  const { intention, isLoading } = useRandomPopularUnprayedIntentionsQuery(community.id)

  if (isLoading) return <View testID={TEST_ID.PUBLICATION.REWARD.SCREEN.INTENTIONS.LOADING} />
  if (!intention) return null

  const handlePray = () => {
    propOnPray?.()
    router.navigate(
      routes.communityJoinNextIntentionPray({
        id: community.id,
        slug: community.slug,
        intentionId: intention?.id,
        shareToken: intention.shareToken || '',
        source: TRACKING_SOURCE.COMMUNITY_JOIN,
      }),
    )
  }

  const defaultTitle = (
    <FormattedMessage
      id="pray.intention.community.show"
      values={{
        user: intention.user?.name,
        lifetime: community.lifetime,
      }}
    />
  )

  const prayedTitle = (
    <FormattedMessage
      id="pray.intention.publication.done"
      values={{
        user: intention.user?.name,
      }}
    />
  )

  return (
    <IntentionPrayCard
      title={{
        default: defaultTitle,
        prayed: prayedTitle,
      }}
      intention={intention}
      onPray={handlePray}
      testIdPrayButton={testID}
    />
  )
}
